import * as History from './undoHistory.ts';

let stackEl: HTMLElement | null = null;
let listEl: HTMLElement | null = null;

const updateStackUI = () => {
  if (!listEl) return;
  const stack = History.getStack();
  const head = History.getHead();
  
  listEl.innerHTML = '';
  
  if (stack.length === 0) {
    listEl.innerHTML = '<div style="color: #999; font-size: 0.8em; padding: 8px; text-align: center;">Stack is empty</div>';
    return;
  }

  // Show stack from newest to oldest
  for (let i = stack.length - 1; i >= 0; i--) {
    const action = stack[i];
    const isPastHead = i > head;
    const isCurrent = i === head;
    
    const item = document.createElement('div');
    item.style.padding = '6px 8px';
    item.style.fontSize = '0.75em';
    item.style.borderBottom = '1px solid #eee';
    item.style.color = isPastHead ? '#aaa' : '#333';
    if (isCurrent) {
      item.style.background = '#e8f4fd';
      item.style.fontWeight = 'bold';
      item.style.borderLeft = '3px solid #0084a4';
    }

    let label = action.label || action.type;
    if (action.type === 'configure' && !action.label) {
      const count = Object.keys(action.paramsAfter).length;
      label = `Configure (${count} params)`;
    } else if (action.type === 'input' && !action.label) {
      label = `Input: ${action.inputId}`;
    }

    item.textContent = `${i}: ${label}`;
    listEl.appendChild(item);
  }
};

/**
 * Toggle the visibility of a floating history stack viewer.
 * Useful for debugging undo/redo behavior.
 */
export function showHistoryStack(show: boolean) {
  if (show) {
    if (!stackEl) {
      stackEl = document.createElement('div');
      stackEl.id = 'floating-history-stack';
      stackEl.style.cssText = 'position: fixed; bottom: 80px; right: 20px; width: 250px; max-height: 400px; background: rgba(255,255,255,0.9); border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); z-index: 10000; display: flex; flex-direction: column; font-family: sans-serif; overflow: hidden; pointer-events: none;';
      stackEl.innerHTML = `
        <div style="background: #0084a4; color: white; padding: 8px 12px; font-size: 0.9em; font-weight: bold; pointer-events: auto;">History Stack</div>
        <div id="history-stack-list" style="overflow-y: auto; flex: 1; padding: 4px; pointer-events: auto;"></div>
      `;
      document.body.appendChild(stackEl);
      listEl = stackEl.querySelector('#history-stack-list');
      window.addEventListener('as-history-changed', updateStackUI);
    }
    stackEl.style.display = 'flex';
    updateStackUI();
  } else {
    if (stackEl) {
      stackEl.style.display = 'none';
    }
  }
}

// Expose to window for console usage
(window as any).showHistoryStack = showHistoryStack;
